var AppConsts = /** @class */ (function () {
    function AppConsts() {
    }
    AppConsts.DEFAULT_PAGE_NUMBER = 1;
    AppConsts.DEFAULT_PAGE_SIZE = 10;
    AppConsts.DEFAULT_PAGE_SIZE_FOLDER = 20;
    AppConsts.SERIAL_NUMBER_LIMIT = 10;
    AppConsts.DEFAULT_SORT_FIELD = 'createdDate';
    AppConsts.DEFAULT_SORT_FIELD_MONGO = 'date';
    AppConsts.DEFAULT_SORT_DIRECTION = 'desc';
    return AppConsts;
}());
export { AppConsts };
